const OnlineExclusive = (
    props: React.SVGProps<SVGSVGElement>
): React.ReactElement => {
    return (
        <svg
            width="10"
            height="17"
            viewBox="0 0 10 17"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
                d="M0 6.31274L0.8 15.0048L2.78 13.0166L4.91 16.4652L7.04 15.4447L4.9 12.0048L7.87 11.6177L0 6.31274Z"
                fill="#1D1D1B"
            />
            <path
                d="M3.46001 5.89041C3.54735 5.89093 3.63376 5.87466 3.71321 5.84275C3.79266 5.81084 3.86324 5.76406 3.92001 5.70566L6.60001 2.97839C6.6535 2.92616 6.69438 2.86493 6.72017 2.79839C6.74595 2.73185 6.75611 2.66139 6.75001 2.59129C6.73479 2.44941 6.6599 2.31764 6.54001 2.22179C6.41796 2.12855 6.25884 2.08174 6.09759 2.09163C5.93634 2.10153 5.78615 2.16733 5.68001 2.27458L3.00001 5.00185C2.89403 5.10922 2.84082 5.24921 2.85207 5.39107C2.86332 5.53293 2.9381 5.66506 3.06001 5.75845C3.17136 5.84274 3.31311 5.8895 3.46001 5.89041Z"
                fill="#1D1D1B"
            />
            <path
                d="M0.980002 4.72028C1.0901 4.79947 1.22779 4.84295 1.37 4.84344H1.42C1.50066 4.83958 1.57955 4.82119 1.65179 4.78941C1.72404 4.75763 1.7881 4.71314 1.84 4.65869C1.94067 4.5499 1.9907 4.41156 1.98 4.27159L1.72 1.12204C1.71496 1.05187 1.69405 0.983283 1.65847 0.920321C1.62289 0.85736 1.57337 0.801286 1.51282 0.755392C1.45227 0.709498 1.38191 0.674708 1.30587 0.653067C1.22983 0.631425 1.14964 0.623367 1.07001 0.629366C0.990242 0.633797 0.912286 0.652205 0.840719 0.683506C0.769153 0.714806 0.705416 0.75837 0.65325 0.811639C0.601084 0.864909 0.561539 0.926812 0.53694 0.993711C0.512341 1.06061 0.503181 1.13116 0.51 1.20122L0.770002 4.35078C0.774392 4.42173 0.795296 4.49114 0.831419 4.5547C0.867542 4.61825 0.918113 4.67461 0.980002 4.72028Z"
                fill="#1D1D1B"
            />
            <path
                d="M8.91006 6.38299C8.8507 6.33593 8.78109 6.29996 8.70545 6.27728C8.62982 6.25459 8.54973 6.24566 8.47006 6.25102L4.89006 6.48857C4.72994 6.49981 4.58132 6.56617 4.47647 6.67323C4.37163 6.7803 4.31901 6.91943 4.33006 7.06041C4.34264 7.19499 4.41242 7.32044 4.52548 7.41176C4.63855 7.50307 4.78658 7.55353 4.94006 7.55308L8.52006 7.32434C8.60026 7.31879 8.67843 7.29935 8.75006 7.26712C8.82168 7.23489 8.88535 7.1905 8.9374 7.13654C8.98945 7.08257 9.02886 7.02007 9.05334 6.95265C9.07782 6.88523 9.0869 6.81422 9.08006 6.7437C9.08176 6.67648 9.06753 6.60969 9.03826 6.54758C9.00899 6.48548 8.96532 6.42943 8.91006 6.38299Z"
                fill="#1D1D1B"
            />
        </svg>
    )
}

export default OnlineExclusive
